import { gql } from '@apollo/client';
import ORGANIZATION_ASSOCIATION_LICENSE_USAGE_FRAGMENT from '../fragments/organization-association-license-usage';

const GET_MY_ORGANIZATIONS_QUERY = gql`
  query getMyOrganizations {
    me {
      organizationAssociations {
        ...BaseOrganizationAssociationLicenseUsage
      }
    }
  }
  ${ORGANIZATION_ASSOCIATION_LICENSE_USAGE_FRAGMENT}
`;

export default GET_MY_ORGANIZATIONS_QUERY;
